import React, { useEffect, useState } from "react";
import "../../assets/css/eventsReport.css"
import "bootstrap/dist/css/bootstrap.css";
import './CJ.css'

function SankeyNode({ icon ,width, height , color,title , id ,styles}) {







    return (

           
            <div id={id} style={ styles}>
                {icon?
                < img style={ {padding:'7px'}} src={icon}/>
                :
            <div style={{ borderRadius: '50%', width: '60%', height: '60%', alignSelf: 'center', backgroundColor:'rgba(100,100,100,0.15)'  }}></div>
                }
                <h6 
                 style={{
                     position: 'absolute',
                     transform: 'translate(-0%, -135%)',
                     fontFamily: 'DM Sans ,sans-serif',
                     fontSize: '10px',
                     fontWeight: '500'


                 }}
                >{title}</h6>
            </div>

    );
}

export default SankeyNode;
